module.exports = __webpack_public_path__ + "static/media/logo.1eeace63.png";